export const checkQuantityAvailability = (quantity: number) => {
  return quantity > 0;
};
